<div
  fxFlex
  fxLayout="column"
  class="editor mat-typography max-w-full"
  [style.font-family]="defaultFont"
  [style.line-height]="defaultLineHeight"
  [style.--paragraph-spacing]="defaultParagraphSpacing"
>
  <pt-menu-bar
    *ngIf="menuEnabled"
    [menuItems]="menuItems$ | async"
    [editor]="editorBloc.editor$ | async"
  />

  <tiptap-editor
    *ngIf="editorBloc.editor$ | async as editor"
    outputFormat="json"
    ptImageUploadDropzone
    ptVideoUploadDropzone
    cdkScrollable
    [uploader]="editorBloc.uploader$ | async"
    [editor]="editor"
    [formControl]="editorCtrl"
  />
</div>
